// extracted by mini-css-extract-plugin
module.exports = {"button":"i_HP","icon":"i_HQ","popover-container":"i_HR","heading":"i_HS"};